/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { bignumberDependencies } from './dependenciesBignumber.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { addDependencies } from './dependenciesAdd.generated.js';
import { isPositiveDependencies } from './dependenciesIsPositive.generated.js';
import { largerDependencies } from './dependenciesLarger.generated.js';
import { largerEqDependencies } from './dependenciesLargerEq.generated.js';
import { smallerDependencies } from './dependenciesSmaller.generated.js';
import { smallerEqDependencies } from './dependenciesSmallerEq.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createRangeTransform } from '../../factoriesAny.js';
export var rangeTransformDependencies = {
  bignumberDependencies,
  matrixDependencies,
  addDependencies,
  isPositiveDependencies,
  largerDependencies,
  largerEqDependencies,
  smallerDependencies,
  smallerEqDependencies,
  typedDependencies,
  createRangeTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesRangeTransform.generated.js
// module id = kc36
// module chunks = 3